const { createContext } = require('react')
// context provider
const StateContext = createContext()

module.exports = StateContext
